import {
    createHandlerChainRunner,
    createHandlerChainRunnerOptionalParameter,
    Handler,
} from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCentro/Store/CustomHandlerCreator";

interface Parameter {
    isGuestandIsOverweight: boolean;
}

type HandlerType = CustomHandler<Parameter>;

export const CenIsGuestIsItemOverweight: HandlerType = props => {
    props.dispatch({
        type: "Pages/isGuestandIsOverweight",
        isGuestandIsOverweight: props.parameter.isGuestandIsOverweight,
    });
};

export const chain = [CenIsGuestIsItemOverweight];

const cenIsGuestIsItemOverweight = createHandlerChainRunner(chain, "CenIsGuestIsItemOverweight");
export default cenIsGuestIsItemOverweight;
